<template>
  <div class="system-wrapper">
    <el-tabs v-model="activeName">
      <!-- tag-01 -->
      <el-tab-pane label="区域配置" name="first">
        <el-scrollbar style="height:100%" :native="false" :noresize="false">
          <!--描述-->
          <div class="desc">
            <span>请在此处管理您单位下的排水户区域.</span>
            <el-button type="primary" size="small" @click="addRegionFun">新增</el-button>
          </div>
          <!--表格渲染-->
          <div class="table-wrapper">
            <el-table :data="tableData"
                      style="width: 100%">
              <el-table-column prop="id" label="主键idid" v-if='false'>
              </el-table-column>
              <el-table-column prop="regionname" label="区域名称">
              </el-table-column>
              <el-table-column prop="describu" label="描述">
              </el-table-column>
              <el-table-column prop="creater" label="创建人" width="200">
              </el-table-column>
              <el-table-column prop="createtime" label="创建时间" :formatter="dateFormat">
              </el-table-column>
              <el-table-column label="操作" width="200">
                <template slot-scope="scope">
                  <el-button type="text" @click='updateRegion(scope.row)' size="small">编辑</el-button>
                  <el-button type="text" @click='deleteRegion(scope.row)' size="small">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-scrollbar>
      </el-tab-pane>
      <!-- tag-02 -->
      <el-tab-pane label="基础设置" name="second" v-if="ifShowBaseConfig">
        <el-scrollbar style="height:100%" :native="false" :noresize="false">
          <!--描述-->
          <div class="desc">系统级别的一些基础配置.
          </div>
          <!--form 表单-->
          <div class="form-wrapper">
            <el-form class="controlform" ref="form" :model="form" label-width="130px">
              <el-form-item label="是否隶属平台">
                <el-switch v-model="form.delivery"></el-switch>
              </el-form-item>
            </el-form>
            <el-form class="listform" ref="form" :model="form" label-width="130px">
              <el-form-item label="系统显示名称">
                <el-input v-model="form.name"></el-input>
              </el-form-item>
              <el-form-item label="是否需要登录">
                <el-switch v-model="form.delivery"></el-switch>
              </el-form-item>
              <el-form-item label="是否需要横幅">
                <el-switch v-model="form.delivery1"></el-switch>
              </el-form-item>
            </el-form>
          </div>
          <div class="buttons">
            <el-button type="primary" size="small">保存</el-button>
            <el-button type="danger" size="small">取消</el-button>
          </div>
        </el-scrollbar>
      </el-tab-pane>

    </el-tabs>
    <!--添加 编辑-->
    <el-dialog :title=tipText :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <el-form :model="dialogForm" :rules="rules" ref="dialogForm">
        <el-form-item label="区域名称：" prop='nameVaule'>
          <el-input v-model="dialogForm.nameVaule" placeholder="请输入区域名称" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="区域描述：">
          <el-input v-model="dialogForm.desc" placeholder="请输入区域描述信息" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="insertRegionFun()" size="small" :loading="dialogForm.loadSwith"
                   v-if="!dialogBtn">新 建
        </el-button>
        <el-button type="primary" @click="updateRegionFun()" size="small" :loading="dialogForm.loadSwith"
                   v-if="dialogBtn">更 新
        </el-button>
      </div>
    </el-dialog>
    <el-dialog title="删除确认" :visible.sync="centerDialogVisible" width="30%" center :close-on-click-modal="false">
      <span>删除后数据将无法恢复，是否将【{{currentRegionName}}】删除？</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="deleteRegionFun" size="medium" :loading="dialogForm.loadSwith">删 除</el-button>
        <el-button @click="centerDialogVisible = false" size="medium">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'System',
  data() {
    return {
      companyId: '',//单位id
      currentRegionId: '',//当前选中的区域id，用于编辑
      userName: '',
      currentRegionName: '', //删除确认框用
      activeName: 'first',
      tipText: '新增区域',
      //TAG1的form
      form: {
        name: '',
        delivery: false,
        delivery1: false,

      },
      //弹框form
      dialogForm: {
        nameVaule: '',
        desc: '',
        loadSwith: false
      },
      //表格数据
      tableData: [],
      dialogFormVisible: false,
      dialogBtn: false,
      centerDialogVisible: false,
      rules: {
        nameVaule: [{
          required: true,
          message: '请输入区域名称',
          trigger: 'blur'
        },
          {
            max: 100,
            message: '长度需小于100个字符',
            trigger: 'blur'
          }
        ]
      }
    };
  },
  created: function () {
    var companyInfo = sessionStorage.getItem('drainage-companyInfo');
    var userInfo = sessionStorage.getItem('drainage-userInfo');
    if (companyInfo && userInfo) {
      this.companyId = JSON.parse(companyInfo).CompanyId;
      this.userName = JSON.parse(userInfo).RealName;
    } else {
      this.$message({
        type: 'error',
        message: '登录信息过期，请重新登录'
      });
      this.$router.push({
        path: '/login'
      });
    }
  },
  mounted() {
    this.findRegionConfigList();
  },
  methods: {
    findRegionConfigList() {
      this.tableData = [];
      this.$http.post(this.basePath + '/sewerageUser/findRegionConfigList/', {
        //  参数
        companyId: this.companyId
      }).then((result) => {
        // debugger
        if (result.data.resCode == 1) {
          if (result.data.data != '') {
            this.tableData = JSON.parse(result.data.data);
          }
        } else {
          this.$message({
            type: 'error',
            message: result.data.msg
          });
        }
      }, (error) => {
        this.$message({
          type: 'error',
          message: '获取数据异常'
        });
      });
    },
    resetFields(formRule) {
      if (this.$refs[formRule] !== undefined) {
        this.$refs[formRule].resetFields();
      }
    },
    addRegionFun() {
      this.resetFields('dialogForm');
      this.dialogForm.nameVaule = '';
      this.dialogForm.desc = '';
      this.dialogBtn = false;
      this.dialogFormVisible = true;
    },
    updateRegion(param) {
      this.resetFields('dialogForm');
      this.dialogForm.nameVaule = '';
      this.dialogForm.desc = '';
      this.dialogBtn = true;
      // 填充数据
      this.currentRegionId = param.id;
      this.dialogForm.nameVaule = param.regionname;
      this.dialogForm.desc = param.describu;

      this.dialogFormVisible = true;
    },
    // 新建区域后台方法
    insertRegionFun() {
      var v = this;
      // 参数规则校验
      v.$refs['dialogForm'].validate((valid) => {
        if (valid) {
          v.dialogForm.loadSwith = true
          // 新建区域
          v.$http.post(v.basePath + '/sewerageUser/insertRegion', {
            //  参数
            companyId: v.companyId,
            regionName: v.dialogForm.nameVaule,
            desc: v.dialogForm.desc,
            creater: v.userName
          }).then((result) => {
            if (result.data.resCode == 1) {
              v.$message({
                type: 'success',
                message: '区域新增成功'
              });
              this.findRegionConfigList();
              v.dialogFormVisible = false;
              v.dialogForm.loadSwith = false;
              // 区域信息修改后业务缓存处需要重新获取，保证数据准确性
              sessionStorage.removeItem('drainage-regionInfo');
            } else {
              v.$message({
                type: 'error',
                message: result.data.msg
              });
              v.dialogFormVisible = false;
              v.dialogForm.loadSwith = false;
            }
          }, (error) => {
            v.$message({
              type: 'error',
              message: '区域新增发生异常'
            });
            v.dialogFormVisible = false;
            v.dialogForm.loadSwith = false;
          });
        } else {
          return false;
        }
      });
    },
    // 新建区域后台方法
    updateRegionFun() {
      var v = this;
      // 参数规则校验
      v.$refs['dialogForm'].validate((valid) => {
        if (valid) {
          v.dialogForm.loadSwith = true
          // 新建区域
          v.$http.post(v.basePath + '/sewerageUser/updateRegion', {
            //  参数
            companyId: v.companyId,
            regionId: v.currentRegionId,
            regionName: v.dialogForm.nameVaule,
            desc: v.dialogForm.desc
          }).then((result) => {
            if (result.data.resCode == 1) {
              v.$message({
                type: 'success',
                message: '区域更新成功'
              });
              this.findRegionConfigList();
              v.dialogFormVisible = false;
              v.dialogForm.loadSwith = false;
              // 区域信息修改后业务缓存处需要重新获取，保证数据准确性
              sessionStorage.removeItem('drainage-regionInfo');
            } else {
              v.$message({
                type: 'error',
                message: result.data.msg
              });
              v.dialogFormVisible = false;
              v.dialogForm.loadSwith = false;
            }
          }, (error) => {
            v.$message({
              type: 'error',
              message: '区域更新发生异常'
            });
            v.dialogFormVisible = false;
            v.dialogForm.loadSwith = false;
          });
        } else {
          return false;
        }
      });
    },
    deleteRegion(param) {
      this.currentRegionId = param.id;
      this.currentRegionName = param.regionname;
      this.centerDialogVisible = true;
    },
    deleteRegionFun() {
      var v = this;
      v.dialogForm.loadSwith = true;
      v.$http.post(v.basePath + '/sewerageUser/deleteRegion', {
        //  参数
        regionId: v.currentRegionId
      }).then((result) => {
        if (result.data.resCode == 1) {
          v.$message({
            type: 'success',
            message: '区域删除成功'
          });
          this.findRegionConfigList();
          v.centerDialogVisible = false;
          v.dialogForm.loadSwith = false;
          // 区域信息修改后业务缓存处需要重新获取，保证数据准确性
          sessionStorage.removeItem('drainage-regionInfo');
        } else {
          v.$message({
            type: 'error',
            message: result.data.msg
          });
          v.centerDialogVisible = false;
          v.dialogForm.loadSwith = false;
        }
      }, (error) => {
        v.$message({
          type: 'error',
          message: '区域删除发生异常'
        });
        v.centerDialogVisible = false;
        v.dialogForm.loadSwith = false;
      });
    },
    dateFormat(row, column) {
      var date = row[column.property];
      if (date == undefined) {
        return "";
      } else {
        return this.time2YMDHMS(date.time);
      }
    },
  }
}
</script>
<style lang='stylus' scoped>
  .listform >>> .el-input
    width: 200px;

  .system-wrapper >>> .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .table-wrapper >>> .el-table td, .el-table th
    padding 2px 0
    min-width 0
    -webkit-box-sizing border-box
    box-sizing border-box
    text-overflow ellipsis
    vertical-align middle
    position relative
    text-align left

  .system-wrapper >>> .el-dialog
    width: 30%

  .system-wrapper >>> .el-tabs
    height: calc(100% - 60px)

  .system-wrapper >>> .el-tabs__content,
  .el-tab-pane
    height: 100%

  .system-wrapper
    height: 100%
    padding 20px
    box-sizing border-box

    .desc
      padding: 15px;
      border-bottom 1px solid #ccc
      margin-bottom 20px;
      font-size 14px
      line-height: 26px
      display: flex

      & > span
        flex 1

    .form-wrapper
      display flex

      .controlform
        width: 30%

      .listform
        border-left 1px solid #ccc
        flex 1


    .buttons
      padding: 35px;
      margin-top 60px
      text-align center

    .table-wrapper
    .paginate-wrapper
      margin-top 10px
      text-align right
</style>



// WEBPACK FOOTER //
// src/components/system/system.vue